'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
require('./NavToggle.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var NavToggle = function (props) {
    var onClick = props.onClick, _a = props.isOffcanvasOpen, isOffcanvasOpen = _a === void 0 ? false : _a;
    return (React__default['default'].createElement("div", { className: 'nb-toggle' },
        React__default['default'].createElement("button", { onClick: onClick }, isOffcanvasOpen ? (React__default['default'].createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" },
            React__default['default'].createElement("path", { d: "M6 18L18 6M6 6L18 18", stroke: "#0A224A", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))) : (React__default['default'].createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" },
            React__default['default'].createElement("path", { d: "M4 6H20M4 12H20M4 18H11", stroke: "#0A224A", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }))))));
};

exports.NavToggle = NavToggle;
//# sourceMappingURL=NavToggle.js.map
